import type { Artifact } from "@/lib/defs"
import { asArray, asString, isRecord } from "@/lib/utils"

/** How one mapping fills a type: its id@version, source system and dataset, and each property's expression. */
export interface MappedFrom {
  readonly mapping: string
  readonly system: string
  readonly dataset: string
  readonly expressions: ReadonlyMap<string, string>
}

/** The installed mapping that writes `typeName`, read from the admitted definitions (never restated). */
export function mappedFrom(artifacts: readonly Artifact[], typeName: string): MappedFrom | null {
  const entity = artifacts.find((a) => a.kind === "entity" && isRecord(a.payload.objectType) && a.payload.objectType.name === typeName)
  if (!entity) return null
  for (const a of artifacts) {
    if (a.kind !== "mapping") continue
    for (const m of asArray(a.payload.maps).filter(isRecord)) {
      if (!isRecord(m.target) || m.target.entity !== entity.artifactId || isRecord(m.source) === false) continue
      const source = isRecord(a.payload.source) ? a.payload.source : {}
      const schema = artifacts.find((s) => s.kind === "source_schema" && s.artifactId === source.schemaId)
      const system = schema && isRecord(schema.payload.source) ? (asString(schema.payload.source.system) ?? "") : ""
      const expressions = new Map(asArray(m.properties).filter(isRecord).map((p) => [String(p.property), String(p.value)]))
      return { mapping: `${a.artifactId}@${a.version}`, system, dataset: isRecord(m.source) ? (asString(m.source.dataset) ?? "") : "", expressions }
    }
  }
  return null
}
